<template>
    <div>
        <!-- Buscar Prescrição -->
        <div class="modal fade" id="prescricaoSelecaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prescrições</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!prescricoes || !prescricoes.length" title="Nenhuma prescrição encontrada." icon="fa-solid fa-pills" />

                        <template v-else>
                            <template v-for="(atend, iax) in prescricoes">
                                <div class="card" v-for="(atp, ipx) in atend.atendimento_procedimentos" :key="iax + '.' + ipx">
                                    <div class="card-header d-flex justify-content-between">
                                        <div>
                                            {{ atp.procedimento.search }}
                                            <div class="small text-muted">
                                                {{ atend.medico.search }}
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            {{ $util.getFormatDate(atend.dt_inicio) }}
                                            <div class="small text-muted">#{{ atend.id_atendimento }}</div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <table class="table mb-0" v-if="atp.anamnese && atp.anamnese.receita">
                                            <tr v-for="(receita, irx) in atp.anamnese.receita" :key="irx">
                                                <td width="1%">
                                                    <a href="#" @click.prevent="selecionar(receita)" class="card-link">
                                                        Selecionar
                                                    </a>
                                                </td>
                                                <td>
                                                    <table class="table table-sm mb-0">
                                                        <tr v-for="(item, iix) in receita.cobranca_items" :key="iix">
                                                            <td width="1%" class="border-0 py-0">
                                                                <i class="fa fa-caret-right" aria-hidden="true"></i> 
                                                            </td>
                                                            <td class="border-0 py-0">
                                                                {{ item.item.search }}
                                                                <span v-if="item.in_quantidade">
                                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                    <span class="text-muted">{{ item.in_quantidade }}{{ item.apresentacao ? ' ' + item.apresentacao.search : 'x' }}</span>
                                                                    <span v-if="item.qtd_calc">
                                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                    <span class="text-muted">{{ item.qtd_calc }}</span>
                                                                    </span>
                                                                </span>
                                                                <span v-if="item.st_ciclo_dias">
                                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                    <span class="text-muted">{{ item.st_ciclo_dias }}</span>
                                                                </span>
                                                                <span class="text-muted" style="white-space: pre-wrap;" v-html="item.complemento"></span>
                                                                <span v-if="item.diluidos && item.diluidos.length">
                                                                    <div v-for="(diluido, idx) in item.diluidos" :key="idx">
                                                                    <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                                                                    {{ diluido.item.search }}
                                                                    <span v-if="diluido.in_quantidade">
                                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                        <span class="text-muted">{{ diluido.in_quantidade }}{{ diluido.apresentacao ? ' ' + diluido.apresentacao.search : 'x' }}</span>
                                                                        <span v-if="diluido.qtd_calc">
                                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                        <strong class="text-muted">{{ diluido.qtd_calc }}</strong>
                                                                        </span>
                                                                    </span>

                                                                    <span v-if="diluido.st_ciclo_dias">
                                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                        <span class="text-muted">{{ diluido.st_ciclo_dias }}</span>
                                                                    </span>
                                                                    </div>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return {
            prescricoes: [],
            callback: null, 
        }
    },

    components: { 
        AzEmptyState, 
    },

    methods: { 
        fechar_modal() { 
            $('#prescricaoSelecaoModal').modal('hide');
        },

        selecionar (receita) { 
            if ( this.callback )
                this.callback(receita);

            this.fechar_modal();
        },

        abrir(atendimento, callback = null) { 
            this.prescricoes = [];
            this.callback = callback;

            this.$util.load(this, { 
                service: 'pep',
                func: 'prescricoes', 
                parms: { 
                    id_paciente: atendimento.id_paciente,
                    infusao: true, 
                },
                loadTo: res => { 
                    this.prescricoes = res.lista;
                }
            });

            $('#prescricaoSelecaoModal').modal('show');
        }
    }
}
</script>
